import { render, staticRenderFns } from "./GatButtonGroup.vue?vue&type=template&id=aa489d6a&scoped=true"
import script from "./GatButtonGroup.vue?vue&type=script&lang=js"
export * from "./GatButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa489d6a",
  null
  
)

export default component.exports